import { AuthServices } from '@/features/auth/services';
import { auth } from '@/features/auth/types';

import type { GuardianPlayer } from './get-guardian-players';

/** Body for POST /api/v1/guardians/me/players (`CreatePlayerRequestDto`). */
export type CreateGuardianPlayerRequest = auth.CreateGuardianPlayerRequest;

/** Creates a player owned by the signed-in guardian; returns the created player. */
export async function createGuardianPlayer(
  data: CreateGuardianPlayerRequest,
): Promise<GuardianPlayer> {
  return await AuthServices.createGuardianPlayer(data);
}
